export const unique = arr => [...new Set(arr)];

// turns [{a:1,b:2},{a:1,b:2}] into [{a:1,b:2}]
// works on simple objects
export const uniqueObjArray = arr =>
  unique(arr.map(obj => JSON.stringify(obj))).map(recordString =>
    JSON.parse(recordString)
  );

// eg turns [[1,2],[3,4]] into [1,2,3,4]
export const flatten2DArray = arr => [].concat(...arr);

// recursive function to split fields with commas into multiple fields
export const spreadOutDataWithCommas = record => {
  const outArr = [];
  Object.keys(record).forEach(key => {
    if (
      record[key] &&
      typeof record[key] === "string" &&
      record[key].includes(",")
    ) {
      record[key].split(",").forEach(string => {
        outArr.push(...spreadOutDataWithCommas({ ...record, [key]: string }));
      });
    }
  });
  if (outArr.length) return outArr;
  return [record];
};

// takes an array of objects and run spreadOutDataWithCommas on them then removes duplicates
export const spreadOutDataWithCommasArr = arr =>
  uniqueObjArray(flatten2DArray(arr.map(spreadOutDataWithCommas)));
